<template>
    <div :style="getStyle()">
        <div class="lineBox">
            <div class="item" v-for="(item,i) in linkData" :key="i">
                <div class="icon" :style="getIcon()" v-if="item.icon"><img :src="item.icon" alt=""></div>
                <div class="name" :style="getTit()">{{ item.title }}</div>
                <div class="smallT" :style="getItem()" v-html="item.content">
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref,reactive,computed,watch } from 'vue';
import { useStore } from 'vuex';
const props = defineProps({
    index:{
        type:Number||String,
        default:0
    }
})
const store = useStore();
const componentList = computed(() => store.state.chartData.componentList);
const optionConfig = reactive(componentList.value[props.index].config);
const linkData = ref([]);
const handleData = (list)=>{ 
    if(!list.length) return
    const regex = /<span[^>]*>(.*?)<\/span>/g;  
    list.map(item=>{
        if(item.content){
            item.content = item.content.replace(regex, `<span style="color:${optionConfig.options.keyColor};font-size:${optionConfig.options.keyFont}px">$1</span>`);
        }   
        return item 
    })
    linkData.value = list
}
watch(
  () => componentList.value[props.index].data,
  (newData) => {
    handleData(newData)
  },
  {
    deep:true,
    immediate: true
  }
)
watch(
  () => optionConfig.options,
  (newVal)=>{
    handleData(linkData.value)
  },
  {deep:true,immediate: true}
)
const getStyle = ()=>{
    return {
        width:`${optionConfig.baseConfig.width}px`,
        height:`${optionConfig.baseConfig.height}px`,
        left:`${optionConfig.baseConfig.left}px`,
        top:`${optionConfig.baseConfig.top}px`,
        background:`${optionConfig.options.bgColor}`,
        position:'relative'
    }
}
const boxStyle = ()=>{
    return {
        'padding-top':`${optionConfig.options.marginTop}%`,
        'padding-left':`${optionConfig.options.marginLeft}%`,
        'padding-bottom':`${optionConfig.options.marginTop}%`,
        'padding-right':`${optionConfig.options.marginLeft}%`
    }
}
const getIcon = ()=>{
    return {
        width:`${optionConfig.options.iconSize}px`,
        height:`${optionConfig.options.iconSize}px`,
    }
}
const getTit = ()=>{
    return {
        'font-size':`${optionConfig.options.titFont}px`,
        'color':`${optionConfig.options.titColor}`
    }
}
const getItem = ()=>{
    return {
        'font-size':`${optionConfig.options.itemFont}px`,
        'color':`${optionConfig.options.itemColor}` 
    }
}
</script>

<style lang="less" scoped>
 .lineBox{
    overflow:hidden;
    padding:15px;
    .item{
        display: flex;
        align-items: center;
        margin-bottom: 1vh;
        .icon{
            margin-right: 0.6vw;
        }
        .icon img{
            width:100%;
            height:100%;
        }
        .name{
            width: 26%;
            margin-right: 0.8vw;
        }
        .smallT{
            flex:1;          
        }       
    }
}
</style>